<template>
	<a href="#" class="swipe-action" :style="buttonStyle"><sym-icon :name="icon"></sym-icon></a>
</template>

<script setup lang="ts">
import SymIcon from "./SymIcon.vue";
import {computed} from "vue";

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "red",
  }
});

const buttonStyle = computed(() => {
  return {
    backgroundColor: props.color,
  };
});
</script>

<style>
.swipe-action {
	color: white;
	min-width: 40px;
	display: inline-flex;
	justify-content: space-around;
	align-items: center;
}
.swipe-action:active,
.swipe-action:visited {
	color: white;
}
</style>
